import React, { PropTypes, Component } from 'react';
import { fetchForDropdown, fetchForContent } from '../api/index';
import ImportModalContent from './ImportModalContent';
import $ from 'jquery';
import cx from 'classnames';

class ImportModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOverWriting: false,
      isDropdownLoading: true,
      isContentLoading: false,
      availableBills: undefined,
      selectedBill: undefined,
    };

    this.copyBill = this.copyBill.bind(this);
    this.tryCopyBill = this.tryCopyBill.bind(this);
  }

  componentDidMount() {
    const {
      caseId,
      isAAST,
      targetId,
      baseUrlForBills,
      baseUrlForBillContent,
      modalType,
    } = this.props;

    const modalId = `#${this.props.modalType}-copy-modal`;

    fetchForDropdown(
      baseUrlForBills + caseId + '&invoiceId=' + targetId + '&aast=' + isAAST,
      json => {
        this.setState({
          availableBills: json,
          isDropdownLoading: false,
          isOverWriting: false,
        });
      }
    );

    $(`.${modalType}.bill.dropdown`).dropdown({
      onChange: value => {
        this.setState({ isContentLoading: true });
        fetchForContent(baseUrlForBillContent + value, json => {
          this.setState({
            selectedBill: { id: value, ...json },
            isContentLoading: false,
            isOverWriting: false,
          });
          $(modalId).modal('refresh');
        });
      },
    });
  }

  copyBill() {
    const { targetId, baseUrlForBillContent } = this.props;
    const { selectedBill } = this.state;
    const withTarget = targetId && `?destId=${targetId}`;

    let url = baseUrlForBillContent + selectedBill.id;
    if (targetId !== 0) {
      url += withTarget;
    }

    $('.copyBill.form').attr('action', url);
    $('.copyBill.form').submit();
  }

  tryCopyBill() {
    const verify = $('.table.billLineList >tbody >tr').length;

    if (verify) {
      this.setState({ isOverWriting: true });
    } else {
      this.copyBill();
    }
  }

  render() {
    const {
      availableBills,
      selectedBill,
      isDropdownLoading,
      isContentLoading,
      isOverWriting,
    } = this.state;
    const { modalType } = this.props;

    const dropdownClasses = cx(
      `ui fluid search selection ${modalType} bill dropdown`,
      { loading: isDropdownLoading }
    );

    const renderActions = () => {
      if (isOverWriting) {
        return (
          <div className="actions">
            <div>
              <div className="left floated" style={{ verticalAlign: 'sub' }}>
                <b>
                  Le contenu de la facture sera écrasé. Confirmez en cliquant
                  une seconde fois.
                </b>
              </div>
              <form className="copyBill form" method="POST">
                <button
                  type="button"
                  className="ui primary button"
                  onClick={this.copyBill}
                >
                  <i className="icon add" />
                  Confirmer copie
                </button>
              </form>
            </div>
          </div>
        );
      }

      return (
        <div className="actions">
          <form className="copyBill form" method="POST">
            <button
              type="button"
              className="ui primary button"
              onClick={this.tryCopyBill}
            >
              <i className="icon add" />
              Copier
            </button>
          </form>
        </div>
      );
    };

    return (
      <div
        id={`${this.props.modalType}-copy-modal`}
        className="ui small long modal bill"
      >
        <i className="close icon" />
        <div className="header">{this.props.title}</div>
        <div className="content">
          <div className={dropdownClasses}>
            <input name="tags" type="hidden" />
            <i className="dropdown icon" />
            <div className="default text">Documents antérieurs</div>
            <div className="menu">
              {availableBills &&
                availableBills.map(bill => (
                  <div className="item" key={bill.id} data-value={bill.id}>
                    {bill.number}
                  </div>
                ))}
            </div>
          </div>
          <div className="ui divider" />
          {selectedBill && (
            <ImportModalContent
              head={availableBills.find(
                bill => bill.id.toString() === selectedBill.id.toString()
              )}
              detail={selectedBill}
              isLoading={isContentLoading}
              modalType={this.props.modalType}
            />
          )}
        </div>
        {renderActions()}
      </div>
    );
  }
}

ImportModal.propTypes = {
  modalType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  baseUrlForBills: PropTypes.string.isRequired,
  baseUrlForBillContent: PropTypes.string.isRequired,
  caseId: PropTypes.number.isRequired,
  isAAST: PropTypes.bool.isRequired,
};

export default ImportModal;



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/components/ImportModal.js